import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {SHORTCUTS} from '../configs/tastenbelegung.config';
import {KundeService} from '../../../services/kunden/kunde.service';
import {StateService} from '../../../services/app/state.service';
import {WebFarbkatlogComponent} from '../../../components/web/web-farbkatalog/web-farbkatalog.component';
import {MatSnackBar} from '@angular/material/snack-bar';

@Injectable()
export class BarrierefreiheitTastenbelegungService {

  public shortcuts = SHORTCUTS

  constructor(
    private router: Router,
    private kundenService: KundeService,
    private stateService: StateService,
    private snackBar: MatSnackBar,
  ) {}

  public pruefeTastaturEingabe(event: KeyboardEvent): void{
    const istMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
    const alternativeTaste = istMac ? event.ctrlKey : event.altKey;
    if (alternativeTaste && event.key.length === 1) {
      const key = event.key.toLowerCase();
      const shortcut = this.shortcuts.find(s => s.key === key);
      if (shortcut) {
        if (shortcut.key == 's'){
          let mandant = this.stateService.mandant.getValue()
          let anzahlSpeiseplaene = Object.keys(mandant.speisePlanIds).length
          let speiseplanId = mandant.speisePlanIds[0].splanId
          shortcut.route = this.kundenService.kunde ? 'speiseplan-kunde' : anzahlSpeiseplaene > 1 ? 'speiseplan-overview' : 'speiseplan-mandant/' + speiseplanId
        }
        if (shortcut.status == 'link') {
          if (shortcut.param == '') {
            this.router.navigate([shortcut.route]);
          } else {
            this.router.navigate([shortcut.route], {queryParams: {id: shortcut.param}})
          }
        }else if (shortcut.status == 'farbkatalog') {
          this.snackBar.openFromComponent(WebFarbkatlogComponent, {
            duration: undefined,
          })
        } else {
          this.fokusElement(shortcut.status)
        }
      }
    }
  }

  public fokusElement(id: string): void {
    const element = document.getElementById(id).firstElementChild;
    if (element) {
      let fokus:any = (element as HTMLElement).focus()
      if (fokus != undefined){
        (element as HTMLElement).focus(); // Fokus setzen
      } else {
        (element.firstElementChild as HTMLElement).focus()
      }
    }
  }
}

